var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"pbrTopicIndustryDistChart",staticClass:"pbr-topic-chart-container",staticStyle:{"height":"190px"}},[_vm._v(" "+_vm._s(_vm.$t('charts.special.industryDistribution'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }